import SMP_CONFIG from '@/util/smp_config';

/**
 * module that contains helper functions for working with region selection
 * @module regionService */

/**
 * decide whether to skip region page or not
 * @param context - component context
 * @returns undefined
 */
const nextRoute = (context) => {
  if (SMP_CONFIG.applicationConfig.regionSelectionConfig && SMP_CONFIG.applicationConfig.regionSelectionConfig.selectable) {
    context.$router.push({ name: 'RegionSelection' });
  } else {
    context.$router.push({ name: 'ServiceSelection' });
  }
};

export default {
  nextRoute
}
